export const formatValue = (value: string) => {
  const str = (value ?? '').trim();
  return str.length > 0 ? str : '-';
};
